module.exports = __webpack_public_path__ + "media/images/login-logo-79234cf6.svg";